module.exports = {
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/witnesscommitment/index.js
// module id = 388
// module chunks = 0